import { useEffect } from "react";

const setMeta = (selector, attr, value) => {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [, name] = selector.match(/\[(?:name|property)="([^"]+)"\]/) || [];
    if (selector.includes('property=')) el.setAttribute("property", name);
    else el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const setLinkCanonical = (href) => {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const useSeo = ({ title, description, path }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:title"]', "content", title || "");
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[property="og:type"]', "content", "website");
      setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
      setMeta('meta[name="twitter:title"]', "content", title || "");
      setMeta('meta[name="twitter:description"]', "content", description);
    }
    if (path) {
      const base = "https://consulting-ia.ch";
      setLinkCanonical(`${base}${path}`);
      setMeta('meta[property="og:url"]', "content", `${base}${path}`);
    }
  }, [title, description, path]);
};
